import { Container } from "reactstrap";
import styled from "styled-components";
import PropTypes from "prop-types";
import Overlay from "./Overlay";
import { ContainerCss, Devices } from "../../../../styles";


const StyledContainer = styled(Container)`
  ${ContainerCss};
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  background-image: url(${(props) => props.$backgroundImage});
  background-size: cover;
  background-position: 75% center;
  background-repeat: no-repeat;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  @media ${Devices.tablet} {
    align-items: center;
    justify-content: center;
    background-position: center center;
  }
  @media ${Devices.desktop} {
    align-items: flex-start;
    padding-top: 6.875rem;
    padding-bottom: 6.875rem;
  }
`;

const Wrapper = ({ backgroundImage, children }) => {
  return (
    <StyledContainer $backgroundImage={backgroundImage} fluid as="section">
      <Overlay />
      {children}
    </StyledContainer>
  );
};

Wrapper.defaultProps = {
  backgroundImage: "",
};

Wrapper.propTypes = {
  backgroundImage: PropTypes.string,
};

export default Wrapper;
